export enum userRole {
  staff = 'Staff',
  admin = 'Admin',
  marketer = 'Marketer',
}

export enum DynamicTypes {
  boolean = 'bool',
  string = 'string',
  number = 'number',
  enum = 'enum',
}

export enum DiscountBy {
  amount = 'Amount',
  percentage = 'Percentage',
}

export enum HoardingType {
  static = 'Static',
  digital = 'Digital',
}

export enum CampaignStatus {
  planning = 'Planning',
  active = 'Active',
  completed = 'Completed',
  paused = 'Paused',
}

export enum CampaignType {
  directClient = 'DirectClient',
  agency = 'Agency',
  vendor = 'Vendor',
}
